import BasicRouterView from "../../components/BasicRouterView.vue";

const biometriaRoutes = {
  path: "biometria",
  redirect: { name: "biometria-biometriatela" },
  meta: {
    label: "biometria",
    icon: "business",
    show: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "biometriatela",
      name: "biometria-biometriatela",
      meta: {
        label: "biometria",
        icon: "business",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "biometria" */ "./views/Biometria.vue"),
    },
  ],
};

export default biometriaRoutes;
